import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  requireAdmin?: boolean;
  requireManagerAccess?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAuth = true,
  requireAdmin = false,
  requireManagerAccess = false,
}) => {
  const { authState, isAdmin, hasManagerAccess } = useAuth();

  // Check authentication
  if (requireAuth && !authState.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check restaurant selection for multi-restaurant users
  if (requireAuth && !authState.currentRestaurant && authState.restaurants.length > 1) {
    return <Navigate to="/select-restaurant" replace />;
  }

  // Check restaurant ID exists
  if (requireAuth && !authState.currentRestaurant) {
    return <Navigate to="/login" replace />;
  }

  // Check admin role
  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  // Check manager access (manager or admin)
  if (requireManagerAccess && !hasManagerAccess()) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
